import React, { Fragment } from 'react'

/*
 * Helper methods
 * Assumption: setInnerHtml(message: string): { __html: string }
 */
import { setInnerHtml } from './utils'

/*
 *  Error message
 */
export interface ErrorMessageProps {
  message: string
  /** Optional analytics value; defaults to 'Message--error' */
  dataAnalytics?: string
}

export const ErrorMessageComponent: React.FC<ErrorMessageProps> = ({ message, dataAnalytics }) => {
  const dataQaError = 'Message--error'
  const dataAnalyticsMsg = dataAnalytics || dataQaError
  return (
    <div
      className='Notification Notification--withIcon Notification--alert u-marginBottom24 u-flexAlignItemsCenter u-flexAlignItemsCenter'
      role='alert'
    >
      <div
        className='Notification-content js-formNotification'
        data-qa={dataQaError}
        data-analytics={dataAnalyticsMsg}
        data-icon={'\ue002'}
      >
        <p dangerouslySetInnerHTML={setInnerHtml(message)} />
      </div>
    </div>
  )
}

/*
 *  Please note content
 */
export interface PleaseNoteProps {
  content: string
}

export const PleaseNoteComponent: React.FC<PleaseNoteProps> = ({ content }) => {
  return (
    <div className='Content u-marginBottom24' dangerouslySetInnerHTML={setInnerHtml(content)} />
  )
}

/*
 *  Send email button
 */
export interface SendEmailButtonProps {
  /** Click handler for the button */
  callback: (event: React.MouseEvent<HTMLButtonElement>) => void
  /** Whether the button is in loading state */
  isLoading: boolean
  /** Label when not loading */
  defaultLabel: React.ReactNode
  /** Label when loading */
  loadingLabel: React.ReactNode
  /** Optional analytics attribute */
  dataAnalytics?: string
}

export const SendEmailButtonComponent: React.FC<SendEmailButtonProps> = ({
  callback,
  isLoading,
  defaultLabel,
  loadingLabel,
  dataAnalytics,
}) => {
  const dataQa = 'Button--send'
  const dataTracking = 'Button'
  const classList = 'Button Button--primary u-sizeFull'

  const showButtonLabels = () => {
    if (isLoading) {
      return (
        <Fragment>
          {loadingLabel}
          <div className='Loading Loading--small'>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
          </div>
        </Fragment>
      )
    }
    return <Fragment>{defaultLabel}</Fragment>
  }

  return (
    <button
      className={classList}
      data-tracking={dataTracking}
      data-qa={dataQa}
      onClick={callback}
      data-analytics={dataAnalytics || dataTracking}
      aria-label={'Send email'}
      type='button'
    >
      {showButtonLabels()}
    </button>
  )
}
